import type { Role } from './enums'

const ROLE_RANK: Record<Role, number> = { reviewer: 1, approver: 2, admin: 3 }

export const hasRole = (actual: Role, required: Role): boolean => ROLE_RANK[actual] >= ROLE_RANK[required]
